import React from 'react'
import { Button, Space } from 'antd-mobile-v5'
import { formatMoney } from '../../components/common/utils'
import { FormattedMessage } from 'react-intl'
import { useTextbookOrder } from '../../services/hooks'

import styles from './PriceList.module.css'

const Coupon = ({ selectedCoupon, setSelectedCoupon, setVisiable, setOrder, submitData }) => {
  const { run } = useTextbookOrder({
    onSuccess: (data) => {
      setOrder(data)
      setVisiable(false)
    },
  })

  const clickSelectCoupon = (coupon) => {
    if (!coupon.available || coupon.expired || coupon.used) return
    const newCoupons = selectedCoupon.map((c) => {
      if (JSON.stringify(c) === JSON.stringify(coupon)) {
        return { ...c, selected: !c.selected }
      }
      if (c.couponType === coupon.couponType) {
        return c
      }
      return { ...c, selected: false }
    })
    setSelectedCoupon(newCoupons)
  }

  const skipCoupon = () => {
    const newCoupons = selectedCoupon.map((c) => {
      return { ...c, selected: false }
    })
    run({ ...submitData, couponDTOS: newCoupons })
    setSelectedCoupon(newCoupons)
  }

  return (
    <div className={styles.couponWrapper}>
      <div className={styles.couponList}>
        {selectedCoupon.map((coupon) => (
          <div
            className={styles.card + ' ' + (coupon.selected && styles.selected)}
            onClick={() => clickSelectCoupon(coupon)}
          >
            <div className={coupon.expired || coupon.used ? styles['tab-disable'] : styles.tab}>
              {coupon.discount ? <FormattedMessage id="coupon" /> : <FormattedMessage id="coupon-voucher" />}
            </div>
            <div className={styles.content}>
              <div className={styles.left}>{coupon.title}</div>
              {coupon.discount && (
                <div className={styles.right}>
                  <span className={coupon.expired || coupon.used ? styles['amount-disable'] : styles.amount}>
                    {formatMoney(coupon.discount, coupon.currencyType)}
                  </span>
                </div>
              )}
            </div>
            {coupon.expired ? (
              <div className={styles.conditions}>
                <span style={{ color: 'red' }}>
                  <FormattedMessage id="coupon-useless" />
                  <FormattedMessage id="coupon-expired" />
                </span>
              </div>
            ) : coupon.used ? (
              <div className={styles.conditions}>
                <span style={{ color: 'red' }}>
                  <FormattedMessage id="coupon-useless" />
                  {/* <FormattedMessage id="coupon-expired" /> */}
                  优惠券已使用
                </span>
              </div>
            ) : (
              <div className={styles.conditions}>
                {coupon.available ? (
                  <FormattedMessage id="coupon-conditions" />
                ) : (
                  <span style={{ color: 'red' }}>
                    <FormattedMessage id="coupon-useless" />
                    {coupon.description}
                  </span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      <Space direction="vertical" block>
        <Button block shape="rounded" onClick={skipCoupon}>
          <FormattedMessage id="coupon-not-to-use" />
        </Button>
        <Button
          block
          shape="rounded"
          color="primary"
          onClick={() => run({ ...submitData, couponDTOS: selectedCoupon })}
        >
          <FormattedMessage id="common-confirm" />
        </Button>
      </Space>
    </div>
  )
}

export default Coupon
